export default {
  name: 'ShopifyInstall',
  data () {
    return {
      isLoading: true,
      error: null,
      shop: null
    }
  },
  methods: {
    processInstall () {
      try {
        const urlParams = new URLSearchParams(window.location.search)
        this.shop = urlParams.get('shop')

        if (!this.shop) throw new Error('Missing shop parameter.')

        const shopPattern = /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/i
        if (!shopPattern.test(this.shop)) throw new Error('Invalid shop domain format.')

        console.log('Shopify app install - storing shop:', this.shop)
        sessionStorage.setItem('shopify_pending_shop', this.shop.toLowerCase())
        const hasToken = Boolean(window.localStorage.getItem('jwt'))
        window.location.href = hasToken ? '/workspace' : '/main'
      } catch (error) {
        console.error('Error processing Shopify install:', error)
        this.error = error.message
        this.isLoading = false
      }
    }
  },
  mounted () {
    this.processInstall()
  }
}
